// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	TABLE_FILTERS: '[data-fragment="TableLayout.tableFilters"]',
	SHOW_FILTERS: '[data-fragment="TableLayout.showFilters"]',
	HIDE_FILTERS: '[data-fragment="TableLayout.hideFilters"]',
	CHECKBOX: '[data-fragment="TableLayout.checkbox"]',
	MARKED_ITEMS: '[data-fragment="TableLayout.markedItems"]',
	MARKED_ITEMS_TITLE: '[data-fragment="TableLayout.markedItemsTitle"]',
	HIDE_MARKED_ITEMS: '[data-fragment="TableLayout.hideMarkedItems"]',
}

export default class TableLayout extends WebComponent {
	didMount() {
		const {
		} = this.props;

		this.tableFilters = this.element.querySelector(fragments.TABLE_FILTERS);
		this.showFilters = this.element.querySelector(fragments.SHOW_FILTERS);
		this.markedItems = this.element.querySelector(fragments.MARKED_ITEMS);
		this.markedItemsTitle = this.element.querySelector(fragments.MARKED_ITEMS_TITLE);

		this.on('click', fragments.SHOW_FILTERS, this.handleClickShowFiltersButton.bind(this));
		this.on('click', fragments.HIDE_FILTERS, this.handleClickHideFiltersButton.bind(this));
		this.on('click', fragments.HIDE_MARKED_ITEMS, this.handleClickHideMarkedItemsButton.bind(this));
		this.on('click', fragments.CHECKBOX, this.handleClickOnCheckbox.bind(this));

		let visibleFilters = false;
		const inputsValue = this.element.querySelectorAll("input[type='text'], select");
		inputsValue.forEach((input) => {
			if(input.value) {
				visibleFilters = true;
			}
		})
		if(!visibleFilters && this.tableFilters) {
			this.tableFilters.classList.add("hidden");
		}
	}


	handleClickShowFiltersButton = (e) => {
		e.preventDefault();
		this.tableFilters.classList.toggle("hidden");
		this.showFilters.classList.add("active");
	}

	handleClickHideFiltersButton = (e) => {
		e.preventDefault();
		this.tableFilters.classList.add("hidden");
		this.showFilters.classList.remove("active");

	}

	handleClickOnCheckbox = (e) => {
		// e.preventDefault();
		const checkedItems = this.element.querySelectorAll("input[type='checkbox']:checked");
		const countSpan = document.createElement("span");
		countSpan.innerHTML = checkedItems.length;
		if(this.markedItemsTitle) {
			this.markedItemsTitle.replaceChild(countSpan, this.markedItemsTitle.querySelector("span"));
		}
		this.tableRowClick(e.target);
		if(checkedItems.length > 0) {
			this.markedItems.classList.remove("hidden");
		} else {
			this.markedItems.classList.add("hidden");
		}
	}

	tableRowClick = (el) => {
		const parentRow = el.closest("tr");
		if(el.checked) {
			parentRow.classList.add("checked");
		} else {
			parentRow.classList.remove("checked");

		}
	}

	handleClickHideMarkedItemsButton = (e) => {
		e.preventDefault();
		this.markedItems.classList.add("hidden");
		const checkedItems = this.element.querySelectorAll("input[type='checkbox']:checked");
		checkedItems.forEach((item) => {
			item.checked = false;
			this.tableRowClick(item);
		})
	}
}



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/TableLayout.js